import { Link } from 'react-router-dom';
import { getTrendingArticles } from '@/mocks/articles';

export default function HeroSection() {
  const trending = getTrendingArticles(3);

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[650px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20abstract%20artistic%20background%20with%20flowing%20organic%20shapes%20in%20coral%20and%20warm%20amber%20tones%2C%20modern%20minimalist%20design%2C%20soft%20gradient%20lighting%2C%20dreamy%20atmosphere%2C%20subtle%20texture%2C%20editorial%20style%2C%20clean%20aesthetic%2C%20no%20text%2C%20abstract%20composition%20with%20smooth%20curves%20and%20warm%20color%20palette&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-fire-line text-accent-400"></i>
            <span className="text-sm text-background-50/90">今日热搜 · 实时更新</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-background-50 font-heading leading-tight mb-4">
            最新鲜的瓜
            <br />
            <span className="text-primary-300">第一时间吃到</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/70 max-w-xl mx-auto leading-relaxed">
            专注娱乐八卦、明星爆料、热门事件的资讯聚合平台。每天更新最新吃瓜内容，让你做最懂吃瓜的人。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 max-w-5xl mx-auto">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group relative rounded-xl overflow-hidden cursor-pointer aspect-[4/3] md:aspect-[3/4] md:col-span-1"
            >
              <img
                src={article.coverImage}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-primary-500 text-background-50 mb-2">
                  {index === 0 ? '头条' : '热门'}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-background-50 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-background-50/60 mt-2">
                  {article.viewCount.toLocaleString()} 阅读
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}